//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDistribution,shareUrl } from '@/model/distribution/distributionService'
import { store , mutations } from '@/observable/store'
import userInfoToast from '@/components/toast/userInfo'
import share from '@/components/toast/share'
import rule from './rule'
import { Share } from '@/utils/commonUtils'

import { getShortLink } from "@/model/api/commonUtilsService";


export default {
  name:'distribution',
  data(){
    return {
      data:'',
      myReward:{},// 我的奖金
      selfRank:{}, // 个人内容
      rankList:[],
      remainTime:'',
      wechat:'超值牙齿清洁保障计划来咯！快戳此处抢购',
      wechat1:'',
      toastText:'您的专属推荐链接已复制',
      day:'',
      hour:'',
      minute:'',
      second:'',
      recommendFlag:'',
      btnText:'我知道了',
      LoginFlag:'',
      loginToken:true,
      syText:'每成功推荐一人购买产品，即可得30元奖励金'
    }
  },
  components:{
    userInfoToast,
    share,
    rule,
  },
  computed: {
    syToken(){
        return store.syToken
    }
  },
  created() {
    this.STATISTICS('load','sybao_ins_activity_first_page')
    this.getDistributionInfo()
    if(!this.syToken || this.syToken == 0){
      this.loginToken = false
    }
  },
  mounted(){
        this.btnText = ''
        this.syText = '活动未开始'
        this.$refs.syToastRef.syToast()

        let obj = {
            'shareContent':'加入新氧保大使，变美变有钱！',
            'shareTimelineContent': '推荐好友购买洗牙，每单可得30元奖金',
            'shareImgurl':  'https://static.soyoung.com/sy-pre/distr-1595495400701.png',
            'shareTitle':  '推荐好友购买洗牙，每单可得30元奖金',
            'shareUrl': `${window.location.href}`,
            'rightBtnStatus': 1
        }

        Share(obj,'sybao_ins_activity_share_result_sys',obj)

        if(this.CHANNAL_ID == 'MWEB'){
        getShortLink({url:window.location.href}).then(res =>{
          this.wechat1 =`邀你成为「新氧保合伙人」，一起瓜分100万奖金。快戳此处参与   ${res}` 
          
        })
        if(this.syToken && this.syToken != 0){
          this.getshareUrl()
        }
          
        }
        
  },
  destroyed(){
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getshareUrl(){
      shareUrl().then(res =>{
          this.wechat =`超值牙齿清洁保障计划来咯！快戳此处抢购   ${res.share}` 
      })
    },
    onCopy(e){
        this.$toast(this.toastText);
    },
    //复制失败
    onError(e){
      this.$toast("复制失败");
    },
    getDistributionInfo(){
      getDistribution().then(data => {
        this.rankList = data.rank_list;
        this.selfRank = data.self_rank;
        this.remainTime = data.remain_time;
        this.myReward = data.my_reward;
        // if(this.syToken && this.syToken != 0){
        //   this.myReward = data.my_reward;
        // }else{
        //   this.myReward = {
        //     bonus: '/',
        //     score: '/'
        //   };
        // }
        if(data.remain_time){
          this.secondsFormat(data.remain_time)
        }
      })
    },
    toastInfo(e){
      this.STATISTICS('click','sybao_ins_distri_prompt_click')
      if(e == 1){
        this.syText = '每成功推荐一人购买产品，即可得30元奖励金'
      }
      if(e == 2){
        this.syText = '好友通过你的链接或海报购买产品，可计入成功推荐人数'
      }
      this.$alert({
        msg:this.syText,
        confirmText:this.btnText,
        onConfirm:()=>{
          console.log("确定的回调")
        }
      })
    },
    bannerClick(){
        this.STATISTICS('click','sybao_ins_distri_index_banner_click',{serial_num:"0"})
        this.$router.push({
            path: "/floorPage",
        })
    },
    shareClick(){
      this.STATISTICS('click','sybao_ins_activity_share_click')
       if(this.CHANNAL_ID == 'MWEB'){
           this.toastText = '已复制活动链接'
       }else{
         this.$refs.shareToast.showoast()
       }
    },
    secondsFormat( s ) { 
      this.count = s;
      this.timer = setInterval(() => {
      if (this.count > 0) {
          this.count--;
          this.day = Math.floor( this.count/ (24*3600) ); // Math.floor()向下取整 
          this.hour = Math.floor( (this.count - this.day*24*3600) / 3600); 
          this.minute = Math.floor( (this.count - this.day*24*3600 - this.hour*3600) /60 ); 
          if(this.minute<10){
            this.minute = `0${this.minute}`
          }
          if(this.hour<10){
            this.hour = `0${this.hour}`
          }
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.showTime = false;
          }
      }, 1000)
      
    },
    loginCallback(e){
      console.log('登陆成功',e)
      this.loginToken = true
      if(this.LoginFlag == 1){
        this.recommend(this.recommendFlag)
      }
      if(this.LoginFlag == 2){
        this.reward()
      }
      this.getDistributionInfo()
      if(this.CHANNAL_ID == 'MWEB'){
        this.getshareUrl()      
      }
    },
    recommend(e){
      this.recommendFlag = e
      e == 'link' ? this.STATISTICS('click','sybao_ins_share_url_click'):this.STATISTICS('click','sybao_ins_share_poster_click')

      if(this.syToken && this.syToken != 0){
        if(e == 'link'){
          shareUrl().then(res =>{
            let url = res.url;
            store.refid.activity_id ? url+=`&activityId=${store.refid.activity_id}`:url;
            store.refid.item_id ? url+=`&from_action=${store.refid.item_id}`:url;
              if(this.CHANNAL_ID == 'MWEB'){
                this.toastText = '您的专属推荐链接已复制'
                // this.wechat =`超值牙齿清洁保障计划来咯！快戳此处抢购   ${res.share}` 
                // this.toastText = '您的专属推荐链接已复制'
                // this.copy()
              }else{
                this.$router.push({
                  path: url
                })
              }
            })
          
        }
        if(e == 'poster'){
          this.$router.push({
            path: "/poster"
          })
        } 
      }
      else{
        this.LoginFlag = 1
        this.$refs.showLogin.showoast()
      }
    },
    // copy(){
    //   console.log('this.$copyText',this.$copyText)
    //   setTimeout(()=>{
    //     this.$copyText(this.wechat).then((e)=> {
    //       this.$toast(this.toastText);
    //       },(e)=> {
    //         this.$toast("复制失败");
    //     })
    //   },300)
    // },
    // 规则
    rule(){    
        this.STATISTICS('click','sybao_ins_activity_rules_click')
        this.$refs.rules.showToast()
    },
    // 查看详情
    reward(){
        this.STATISTICS('click','sybao_ins_bonus_detail_click')
        if(this.syToken && this.syToken != 0){
          this.$router.push({
            path: "/reward"
          })
        }else{
          this.LoginFlag = 2
          this.$refs.showLogin.showoast()
        }
        
    },
  }
}
